/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Display-only portion of an accepted total. Contains no payment or supplier identifiers.
 * @export
 * @interface FlightChargeComponent
 */
export interface FlightChargeComponent {
  /**
   *
   * @type {string}
   * @memberof FlightChargeComponent
   */
  kind: FlightChargeComponentKindEnum;
  /**
   *
   * @type {string}
   * @memberof FlightChargeComponent
   */
  timing: FlightChargeComponentTimingEnum;
  /**
   *
   * @type {number}
   * @memberof FlightChargeComponent
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof FlightChargeComponent
   */
  currency: string;
}

/**
 * @export
 */
export const FlightChargeComponentKindEnum = {
  Air: "air",
  Ancillaries: "ancillaries",
} as const;
export type FlightChargeComponentKindEnum =
  (typeof FlightChargeComponentKindEnum)[keyof typeof FlightChargeComponentKindEnum];

/**
 * @export
 */
export const FlightChargeComponentTimingEnum = {
  Booking: "booking",
  AfterTicketing: "after_ticketing",
} as const;
export type FlightChargeComponentTimingEnum =
  (typeof FlightChargeComponentTimingEnum)[keyof typeof FlightChargeComponentTimingEnum];

/**
 * Check if a given object implements the FlightChargeComponent interface.
 */
export function instanceOfFlightChargeComponent(
  value: object
): value is FlightChargeComponent {
  if (!("kind" in value) || value["kind"] === undefined) return false;
  if (!("timing" in value) || value["timing"] === undefined) return false;
  if (!("amount" in value) || value["amount"] === undefined) return false;
  if (!("currency" in value) || value["currency"] === undefined) return false;
  return true;
}

export function FlightChargeComponentFromJSON(
  json: any
): FlightChargeComponent {
  return FlightChargeComponentFromJSONTyped(json, false);
}

export function FlightChargeComponentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightChargeComponent {
  if (json == null) {
    return json;
  }
  return {
    kind: json["kind"],
    timing: json["timing"],
    amount: json["amount"],
    currency: json["currency"],
  };
}

export function FlightChargeComponentToJSON(json: any): FlightChargeComponent {
  return FlightChargeComponentToJSONTyped(json, false);
}

export function FlightChargeComponentToJSONTyped(
  value?: FlightChargeComponent | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    kind: value["kind"],
    timing: value["timing"],
    amount: value["amount"],
    currency: value["currency"],
  };
}
